import useFormSubmit from "@/hooks/useFormSubmit";
import { siteInfo } from "@/mocks/dramas";

const SUBMIT_ADDR = "https://readdy.ai/api/form/daihu4joh653ivfvodog";

const CONTACT_ITEMS = [
  { icon: "ri-mail-line", label: "电子邮箱", value: siteInfo.email },
  { icon: "ri-time-line", label: "回复时效", value: "两个工作日内" },
  { icon: "ri-chat-smile-2-line", label: "合作与建议", value: "内容纠错、选题建议均欢迎" },
];

export default function ContactSection() {
  const { status, message, submit } = useFormSubmit(
    SUBMIT_ADDR,
    "留言已收到！我们会在两个工作日内回复你。"
  );

  return (
    <section id="contact" className="border-t border-background-200/60 bg-background-100/50 py-16 md:py-20" aria-labelledby="contact-title">
      <div className="mx-auto grid max-w-page grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-[0.9fr_1.1fr]">
        <div>
          <span className="text-xs font-label tracking-[0.3em] text-accent-400">联系方式</span>
          <h2 id="contact-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            有问题、想推荐好剧，都可以找我们
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            无论你是想反馈某部剧的信息有误，还是想把自己追到的好剧推荐给我们，都欢迎留言。
            我们会认真对待每一条反馈，并把它用在榜单与内容的更新上。
          </p>

          <ul className="mt-8 space-y-4">
            {CONTACT_ITEMS.map((item) => (
              <li
                key={item.label}
                className="flex items-start gap-4 rounded-lg border border-background-200/70 bg-background-50 p-5"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-accent-400">
                  <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <span>
                  <span className="block text-xs font-label text-foreground-500">{item.label}</span>
                  <span className="mt-1 block text-sm text-foreground-900">{item.value}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>

        <form
          onSubmit={submit}
          data-readdy-form
          id="contact-form"
          className="rounded-lg border border-background-200/70 bg-background-50 p-6 md:p-8"
          noValidate
        >
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            <div>
              <label htmlFor="contact-name" className="block text-xs font-label text-foreground-600">
                昵称
              </label>
              <input
                id="contact-name"
                name="name"
                type="text"
                required
                autoComplete="name"
                placeholder="怎么称呼你"
                className="mt-2 w-full rounded-md border border-background-300/70 bg-background-100 px-3.5 py-3 text-sm font-label text-foreground-950 placeholder:text-foreground-500 focus:border-primary-400 focus:outline-none"
              />
            </div>
            <div>
              <label htmlFor="contact-email" className="block text-xs font-label text-foreground-600">
                邮箱
              </label>
              <input
                id="contact-email"
                name="email"
                type="email"
                required
                autoComplete="email"
                placeholder="you@example.com"
                className="mt-2 w-full rounded-md border border-background-300/70 bg-background-100 px-3.5 py-3 text-sm font-label text-foreground-950 placeholder:text-foreground-500 focus:border-primary-400 focus:outline-none"
              />
            </div>
          </div>

          <div className="mt-5">
            <label htmlFor="contact-topic" className="block text-xs font-label text-foreground-600">
              留言类型
            </label>
            <select
              id="contact-topic"
              name="topic"
              defaultValue="推荐好剧"
              className="mt-2 w-full rounded-md border border-background-300/70 bg-background-100 px-3.5 py-3 text-sm font-label text-foreground-950 focus:border-primary-400 focus:outline-none"
            >
              <option value="推荐好剧">推荐好剧</option>
              <option value="内容纠错">内容纠错</option>
              <option value="选题建议">选题建议</option>
              <option value="合作咨询">合作咨询</option>
            </select>
          </div>

          <div className="mt-5">
            <label htmlFor="contact-message" className="block text-xs font-label text-foreground-600">
              留言内容
            </label>
            <textarea
              id="contact-message"
              name="message"
              rows={5}
              maxLength={500}
              required
              placeholder="想说的内容，最多 500 字"
              className="mt-2 w-full resize-none rounded-md border border-background-300/70 bg-background-100 px-3.5 py-3 text-sm font-label leading-relaxed text-foreground-950 placeholder:text-foreground-500 focus:border-primary-400 focus:outline-none"
            ></textarea>
          </div>

          <input
            className="contact-field-verify"
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />

          <button
            type="submit"
            disabled={status === "loading"}
            className="mt-6 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-label font-medium text-background-950 transition-colors hover:bg-primary-400 disabled:opacity-60 cursor-pointer"
          >
            <i className="ri-send-plane-line" aria-hidden="true"></i>
            {status === "loading" ? "提交中…" : "提交留言"}
          </button>

          {message && (
            <p
              role="status"
              className={`mt-3 text-xs leading-relaxed ${
                status === "success" ? "text-accent-400" : "text-primary-400"
              }`}
            >
              {message}
            </p>
          )}
        </form>
      </div>
    </section>
  );
}